import { offer, whatsappPrefill } from "@/config/site";
import { Reveal } from "./Reveal";

export const EmotionalClose = () => (
    <section
        aria-labelledby="emotional-close-title"
        className="relative overflow-hidden border-t border-rz-steel/60"
    >
        <img
            src="/assets/work/studio-wide-aprons.webp"
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-rz-black/85" />
        <div className="relative mx-auto max-w-[1440px] px-5 py-28 sm:px-8 lg:px-12 lg:py-44">
            <Reveal>
                <p className="font-display text-[11px] uppercase tracking-[0.25em] text-rz-smoke">
                    <span className="text-rz-red">17</span>
                    <span className="mx-2 text-rz-steel">/</span> Revautoz
                </p>
                <h2
                    id="emotional-close-title"
                    className="mt-5 max-w-4xl font-display text-4xl font-bold uppercase leading-[1.0] tracking-tight text-rz-white sm:text-5xl lg:text-7xl"
                >
                    Your car deserves more.
                </h2>
                <p className="mt-5 max-w-xl text-base text-rz-smoke sm:text-lg">
                    Precision automotive care, protection, restoration and customization by
                    Revautoz.
                </p>
                <a
                    href={whatsappPrefill(offer.message)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="emotional-close-cta"
                    className="btn-sweep mt-10 inline-block bg-rz-red px-10 py-4 font-display text-[13px] font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-rz-reddeep"
                >
                    {offer.cta}
                </a>
            </Reveal>
        </div>
    </section>
);
